// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__iwomz","item":"style_item__I05__"};